import { styled } from "@mui/material/styles";
import { Button } from "../../../components";

export const BookingInterestsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  width: "100%",
  gap: theme.space._500
}));

export const CTAContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.space._400,
  alignSelf: "strech",
  marginTop: theme.space._400
}));